import ContextProvider, { Context } from "./Context";

export { Context };
export default ContextProvider;
